import { Grid } from '@mui/material';
import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import Button from '../../../react-components/Button';
import { Text } from '../../../react-components/Text';

interface RegisterWelcomeProps {
  phone: string;
  nextStep: () => void;
}

export const RegisterWelcome = ({ phone, nextStep }: RegisterWelcomeProps) => {
  return (
    <Grid container flexDirection="column" justifyContent="flex-start" flexGrow="1" gap="24px">
      <Grid style={{ padding: `12px` }}>
        <Text
          variant="h4"
          intlId="drivers.register.welcome"
          style={{ color: RoutalPalette.neutral60, textAlign: `center` }}
        />
        <VSpacer medium />
        <Text
          variant="h6"
          style={{ textAlign: `center` }}
          intlId="drivers.register.welcome.info_1"
          intlValues={{ phone }}
        />
        <VSpacer medium />
        <Text
          variant="body"
          intlId="drivers.register.welcome.info_2"
          style={{ color: RoutalPalette.secondary00, textAlign: `center` }}
          intlValues={{ phone }}
        />
      </Grid>
      <Button
        onClick={() => nextStep && nextStep()}
        styleType="primary"
        style={{
          fontSize: `14px`,
        }}
        intlId="drivers.register.next"
      />
    </Grid>
  );
};
